@if (totalNotifications() > 0) {
<mat-accordion>
    <mat-expansion-panel [expanded]="true" (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
        <mat-expansion-panel-header class="header-centro">
            <mat-panel-title>
                <div class="icon-container rojo">
                    <!-- <i class="bi bi-bell"></i> -->
                    <app-icon color="#fff" strokeColor="#fff" [name]="'notificacion'" [strokeWidth]="5" size="2em">
                    </app-icon>
                </div>
                <div class="text">
                    <p class="text-title notificaciones-title">{{ 'HOME.NOTIFICACIONES' | translate }}</p>
                    <p>
                        {{ summaryMessage() }}
                    </p>

                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="notificaciones">
            @for (notification of translatedNotifications(); track $index) {
            <p>{{ notification }}</p>
            @if (!$last) {
            <hr>
            }
            }
        </div>

    </mat-expansion-panel>
</mat-accordion>
}
